const vi = {
  common: {
    loading: "Đang tải...",
    please_wait: "Vui lòng chờ",
    kent_project: "Sản phẩm của KenT Project"
  },
  nav: {
    home: "Trang chủ",
    gallery: "Thư viện ảnh",
    guide: "Hướng dẫn",
    create_frames: "Tự tạo Frame",
    how_to_use: "Cách sử dụng",
    about: "Giới thiệu",
    contact: "Liên hệ"
  },
  home: {
    welcome_to: "Welcome to",
    subtitle: "Chụp ảnh online với hàng trăm khung hình hot trend 2026. Không cần tải app, không watermark, bảo mật riêng tư — chụp xong, chia sẻ ngay!",
    start_capture: "BẮT ĐẦU CHỤP",
    view_gallery: "XEM THƯ VIỆN",
    follow_social: "Theo dõi KenT Photobooth ở Facebook và Tiktok",
    social_popup_title: "Theo dõi chúng mình nhé!",
    social_popup_desc: "Kết nối với KenT Photobooth trên Facebook và TikTok để không bỏ lỡ các thông tin và frame hình mới nhất.",
    explore_now: "Khám phá ngay",
    memory_corner: "Góc Nhỏ Kỷ Niệm",
    how_to_shoot: "Cách chụp ảnh photo booth?",
    card1_title: "Chọn khung ảnh",
    card1_desc: "Chọn khung, nhấn \"Tiếp tục\" và bắt đầu chụp thôi bạn!",
    card2_title: "Chụp ảnh và tải ảnh lên",
    card2_desc: "Sau khi chụp, nhấn tiếp tục để đến trang tiếp theo, muốn chụp lại 1 tấm duy nhất thì chọn vào một tấm anh rồi bấm chụp lại.",
    card3_title: "Chọn khung hình và Tải xuống",
    card3_desc: "Chọn màu hoặc là chọn frame cho khung ảnh, nhấp vào \"Tải xuống\" để chia sẻ.",
    feature_title: "Chụp photobooth như ngoài tiệm ngay tại nhà hoàn toàn miễn phí",
    feature_sub1: "Trải nghiệm mượt mà",
    feature_sub2: "Không cần đăng ký tài khoản",
    feature_sub3: "Không quảng cáo",
    feature_sub4: "Không watermark",
    feature_layout_title: "Nhiều layout và nhiều frame",
    feature_layout_desc: "Thỏa sức sáng tạo với hàng loạt bố cục và khung hình đa dạng, từ cổ điển đến hiện đại, giúp bức ảnh của bạn trở nên độc đáo hơn bao giờ hết.",
    feature_filter_title: "Hiệu ứng filter photobooth đẹp mắt",
    feature_filter_desc: "Bộ lọc màu được tinh chỉnh riêng cho phong cách photobooth, giúp làn da rạng rỡ và màu sắc trong trẻo như chụp tại máy chuyên nghiệp.",
    feature_share_title: "Nhấp chuột là chia sẻ với mọi người",
    feature_share_desc: "Dễ dàng tải xuống hoặc chia sẻ nhanh chóng qua mã QR, lan tỏa niềm vui cùng bạn bè và người thân chỉ trong tích tắc.",
    shoot_now: "Chụp ảnh ngay"
  },
  gallery: {
    title: "Thư viện ảnh",
    heading: "Khoảnh Khắc Của Bạn 💙",
    photo_count: "ảnh",
    secure: "Bảo mật 100%",
    free: "Miễn phí",
    send_photo: "Gửi ảnh của bạn cho mình nhé!",
    description: "Những bức ảnh chân thực nhất từ người dùng gửi về — mỗi tấm là một kỷ niệm đáng nhớ. Trừ tính năng chia sẻ bằng mã QR thì website sẽ không lưu trữ bất kỳ hình ảnh nào của bạn, cứ an tâm 100% nhé! Bạn có thể chọn gửi cho chúng mình lúc tải xuống hoặc là bấm vào nút bên cạnh!",
    loading_more: "Đang tải thêm...",
    no_photos: "Chưa có ảnh nào"
  },
  guide_create: {
    title: "Hướng Dẫn Tạo Khung",
    subtitle: "Hướng Dẫn Tạo Khung Bằng Canva",
    desc1: "Website của mình đã chuẩn bị các frame cơ bản để bạn có thể sáng tạo theo ý thích! 🎨",
    desc2: "Khung của bạn tạo ra có thể sử dụng tính năng dùng khung riêng nhé!",
    step1_title: "Chọn Mẫu Frame Canva",
    template4: "Mẫu 4 Ảnh (1x4)",
    template4_desc: "Dành cho bố cục chụp 4 ảnh dọc.",
    template6: "Mẫu 6 Ảnh (2x3)",
    template6_desc: "Dành cho bố cục chụp 6 ảnh.",
    template2: "Mẫu 2 Ảnh (2x2)",
    template2_desc: "Dành cho bố cục chụp 2 ảnh.",
    template3: "Mẫu 3 Ảnh (1x3)",
    template3_desc: "Dành cho bố cục chụp 3 ảnh dọc.",
    use_template: "Dùng Mẫu Này",
    step2_title: "Sáng Tạo Theo Phong Cách Của Bạn",
    step2_illustration: "✨ Minh họa thiết kế trên Canva",
    step2_after: "Sau khi mở mẫu, bạn có thể thoải mái:",
    step2_li1: "Thay đổi màu sắc",
    step2_li2: "Thêm sticker, họa tiết (kể cả loại Pro)",
    step2_li3: "Chèn chữ viết, tên của bạn",
    step2_note_title: "Lưu ý quan trọng:",
    step2_note_desc: "Giữ nguyên phần ô màu ở khung nhỏ (màu xám hoặc màu xanh hoặc là cái ô vuông để chứa ảnh) ở giữa để làm nền xóa.",
    step2_tip: "💡 Mọi người có thể tải frame chỉ có background trước rồi xóa phông sau đó mới vứt lại lên canva để lắp thêm sticker (tránh việc xóa bị lem nhem vào sticker có độ phức tạp cao)",
    step3_title: "Tải Ảnh Về",
    step3_desc: "Sau khi thiết kế xong, tải khung mới tạo về máy để chuẩn bị sử dụng!",
    step4_title: "Xóa Nền Bằng Photopea",
    step4_desc: "🖼️ Hướng dẫn xóa nền trên Photopea",
    step4_li1: "Truy cập Photopea.com",
    step4_li2: "Kéo file ảnh hoặc 'Ctrl + O' để mở ảnh bạn vừa tải từ Canva vào giao diện.",
    step4_li3: "Chọn công cụ Magic Wand (Cây Đũa Thần).",
    step4_li4: "Nhấp chuột vào vùng màu ở giữa để chọn nó.",
    step4_li5: "Nhấn phím Delete trên bàn phím.",
    step4_li6: "Vào File > Export as > PNG. Nhấn Save.",
    step5_title: "Hoàn Tất & Cộng Đồng",
    step5_desc1: "✨ Giờ bạn đã có file PNG nền trong suốt! Hãy quay lại website, nhấn nút \"Tải Khung Cá Nhân\" ở trang chọn khung và tải nó lên để sử dụng nó riêng tư nhé.",
    step5_desc2: "🔒 Website không lưu trữ bất kì hình ảnh gì đâu nhé, nên bạn cứ yên tâm mà sài !!!",
    step5_community: "Chung Tay Xây Dựng Cộng Đồng",
    step5_community_desc1: "Nếu bạn đã tạo ra một chiếc khung thật đẹp và tâm đắc, và muốn chia sẻ nó cho mọi người cùng sử dụng trên website này, đừng ngần ngại gửi file PNG của bạn cho mình qua Instagram nhé.",
    step5_community_desc2: "💜 Sự đóng góp của bạn sẽ làm cho thư viện khung của chúng ta thêm phong phú. Cảm ơn bạn rất nhiều! ❤️"
  },
  guide_use: {
    title: "Hướng Dẫn Sử Dụng",
    subtitle: "Chỉ với 5 bước đơn giản, bạn đã có thể tạo ra những bức ảnh photobooth độc đáo và lưu giữ kỷ niệm cùng bạn bè!",
    step: "Bước",
    step1_title: "Bắt đầu hành trình",
    step1_desc: "Tại trang chủ, hãy nhấn vào nút \"Bắt đầu chụp\". Đừng quên cấp quyền truy cập camera cho trình duyệt nhé! (Hình ảnh chỉ xử lý trên máy của bạn nên vô cùng bảo mật).",
    step2_title: "Lựa chọn bố cục",
    step2_desc: "Lướt xem và chọn cho mình một bố cục chụp ảnh ưng ý nhất. Có rất nhiều bố cục xinh xắn đang chờ bạn.",
    step3_title: "Tạo dáng & Chụp ảnh",
    step3_desc: "Thoải mái chọn bộ lọc màu hoặc hiệu ứng phù hợp. Căn chỉnh góc máy, tạo dáng và chụp! Sau khi hoàn thành, hãy nhấn \"Tiếp tục\".",
    step4_title: "Trang trí khung ảnh",
    step4_desc: "Làm cho bức ảnh thêm nổi bật bằng cách chọn màu nền tệp với phong cách của bạn, hoặc dùng trực tiếp các mẫu Frame cực kỳ bắt mắt trong thư viện.",
    step5_title: "Lưu giữ & Chia sẻ",
    step5_desc: "Tác phẩm đã hoàn thành! Bạn có thể tải ngay ảnh chất lượng cao về máy, hoặc dùng tính năng \"Chia sẻ QR\" để gửi nhanh cho bạn bè quét tải về trong nháy mắt.",
    ready: "Bạn đã sẵn sàng chưa?",
    create_frame_btn: "Tự tạo khung ảnh",
    start_btn: "Bắt đầu chụp ngay",
    faq_title: "Câu Hỏi Thường Gặp",
    q1: "KenT Photobooth là gì?",
    a1: "KenT Photobooth là một ứng dụng web cho phép bạn chụp ảnh phong cách photobooth ngay trên trình duyệt của máy tính hoặc điện thoại mà không cần cài đặt phần mềm.",
    q2: "Website có lưu trữ ảnh của tôi không?",
    a2: "Hoàn toàn không. Mọi quy trình xử lý ảnh đều diễn ra ngay trên trình duyệt của bạn (Client-side). Ảnh chỉ được lưu trữ tạm thời trên máy chủ khi bạn chủ động chọn tính năng 'Chia sẻ QR' để tải ảnh về điện thoại.",
    q3: "Tính năng chia sẻ QR có an toàn không?",
    a3: "Rất an toàn. Link chia sẻ sẽ tự động hết hạn và xóa sạch dữ liệu trên máy chủ sau 1 tuần. Không ai có thể xem ảnh nếu không có link hoặc mã QR của bạn.",
    q4: "Tôi có thể sử dụng khung ảnh tự thiết kế không?",
    a4: "Có chứ! Bạn có thể vào phần 'Tự tạo Frame' để xem hướng dẫn cách tạo khung riêng bằng Canva và Photopea, sau đó tải lên để sử dụng riêng tư.",
    q5: "Website có mất phí không?",
    a5: "Website hoàn toàn miễn phí 100%. Bạn có thể ủng hộ mình (Donate) bằng cách nhấn vào mục 'Liên hệ' để mình có thêm động lực duy trì server nhé!",
    steps_title: "Các bước thực hiện",
    still_need_help: "Vẫn cần hỗ trợ?",
    help_desc: "Nếu bạn gặp bất kỳ vấn đề gì khi sử dụng hoặc muốn đóng góp ý kiến, đừng ngần ngại nhắn tin cho chúng mình nhé!",
    contact_now: "Liên hệ ngay"
  },
  contact: {
    donate_title: "☕ Ủng hộ tôi một ly cà phê nhé!",
    donate_desc: "Giúp tôi có động lực duy trì server và phát triển thêm nhiều tính năng mới! 💕",
    admin_badge: "Admin",
    contact_info: "Thông Tin Liên Hệ",
    contact_desc: "Website Photobooth này tôi code để tặng cho mhoa cute của toi 🥰💕",
    fb_page1: "Facebook Page",
    fb_page2: "Facebook Page"
  },
  about: {
    welcome: "Chào mừng bạn đến với KenT PhotoBooth",
    title1: "Lưu giữ khoảnh khắc",
    title2: "Theo cách của bạn",
    desc: "Chúng tôi mang đến trải nghiệm phòng chụp ảnh chuyên nghiệp ngay trên trình duyệt của bạn. Nhanh chóng, riêng tư và hoàn toàn miễn phí.",
    team_title: "Đội Ngũ Phát Triển",
    author_title: "Tác giả: Quế Minh Thành (Dev 2k8)",
    author_desc: "Chàng trai trẻ sinh năm 2008, người đặt nền móng và xây dựng toàn bộ hệ thống KenT PhotoBooth. Với đam mê công nghệ và sáng tạo, KenT Software đã hiện thực hóa ý tưởng về một photobooth trực tuyến tiện lợi cho mọi người.",
    designer_title: "Thiết kế khung hình: Quế Minh Thành, Quế Mai Hương",
    designer_desc: "Đội ngũ đứng sau những mẫu khung ảnh lung linh và đa dạng phong cách. Tỉ mỉ trong từng chi tiết để đảm bảo mỗi bức ảnh của bạn đều trở nên đặc biệt và mang đậm dấu ấn cá nhân.",
    journey_title: "Hành Trình Phát Triển",
    m1_title: "Khởi công dự án",
    m1_desc: "Đặt những viên gạch đầu tiên cho ý tưởng về một phòng chụp ảnh kỹ thuật số. Dự án bắt đầu với khát vọng mang lại niềm vui qua từng khung hình.",
    m2_title: "Bản Final đầu tiên",
    m2_desc: "Sau gần 2 tháng phát triển miệt mài, phiên bản hoàn chỉnh đầu tiên đã chính thức ra đời, đánh dấu một cột mốc quan trọng trong hành trình sáng tạo.",
    m3_title: "Public trực tuyến",
    m3_desc: "Chính thức đưa dự án lên môi trường mạng. Ban đầu được xây dựng từ HTML, CSS và JS thuần túy, hoạt động sôi nổi trong 3 tuần đầu tiên.",
    m4_title: "Tái cấu trúc & React",
    m4_desc: "Bước ngoặt lớn khi toàn bộ mã nguồn được chuyển đổi sang nền tảng React hiện đại. Đồng thời, thành lập Facebook KenT Photobooth để kết nối người dùng.",
    m5_title: "Ra mắt chính thức lại",
    m5_desc: "Chính thức trở lại với diện mạo mới, hiệu suất vượt trội và hoạt động ổn định cho đến ngày hôm nay.",
    features_title1: "Bảo mật tuyệt đối",
    features_desc1: "Dữ liệu của bạn được bảo vệ nghiêm ngặt, xử lí trên chính máy bạn. Ảnh chỉ được lưu trữ trên máy chủ khi bạn dùng tính năng chia sẻ QR.",
    features_title2: "Kho khung hình đồ sộ",
    features_desc2: "Cập nhật liên tục các xu hướng mới nhất: Y2K, Aesthetic, Vintage, và nhiều chủ đề đa dạng khác.",
    features_title3: "Hoàn toàn miễn phí",
    features_desc3: "Trải nghiệm toàn bộ tính năng cao cấp mà không tốn phí. Niềm vui của bạn là động lực để chúng mình phát triển.",
    features_title4: "Chia sẻ tức thì",
    features_desc4: "Tạo mã QR và gửi ảnh cho bạn bè chỉ trong vài giây. Tiện lợi và cực kỳ nhanh chóng.",
    features_title5: "Trải nghiệm mượt mà",
    features_desc5: "Giao diện tối ưu, hoạt động trơn tru trên mọi thiết bị từ điện thoại đến máy tính.",
    features_title6: "Chất lượng sắc nét",
    features_desc6: "Ảnh được xuất ra với độ phân giải cao, đảm bảo từng chi tiết kỉ niệm của bạn luôn rạng rỡ và rõ nét nhất.",
    cta_title: "Sẵn sàng cho những bức ảnh đẹp?",
    cta_desc: "Gia nhập cộng đồng người dùng KenT PhotoBooth và bắt đầu sáng tạo ngay hôm nay.",
    cta_btn: "Bắt đầu chụp ảnh",
    users: "1000+ Người dùng"
  },
  photo_layout: {
    title: "Hãy chọn khung ảnh bạn muốn!",
    subtitle: "Website sẽ cập nhật thêm frame mới trong tương lai. 🌸",
    photos: "ảnh",
    start_btn: "Bắt đầu chụp",
    alert_select: "Vui lòng chọn một bố cục trước khi tiếp tục.",
    layout_prefix: "Bố cục",
  },
  take_photo: {
    record_video_btn: "Quay Video",
    settings_btn: "Cài đặt",
    layout_label: "Bố cục:",
    reselect_layout: "Chọn lại bố cục",
    confirm_reselect: "Bạn có chắc muốn chọn lại bố cục không? Các ảnh đã chụp sẽ bị mất.",
    upload_photos: "Tải ảnh lên",
    camera: "Camera",
    confirm_upload: "Bạn có chắc chắn muốn chuyển sang tải ảnh lên không? Các ảnh đã chụp sẽ bị mất.",
    confirm_exit_video_mode: "Bạn có muốn đổi chế độ khi chưa chụp xong không? Ảnh hiện tại sẽ bị mất.",
    flash_toggle: "Bật/Tắt hiệu ứng Flash chớp màn hình",
    flip_camera: "Lật Camera (Mirror)",
    alert_camera_off: "Vui lòng bật camera trước!",
    confirm_retake: "Bạn có chắc chắn muốn chụp lại ảnh #",
    confirm_change: "Bạn có muốn đổi ảnh này không?",
    alert_need_photos: "Cần đủ {requiredPhotos} ảnh để tiếp tục!",
    filter_normal: "Thường",
    filter_gray: "Xám",
    filter_sepia: "Nâu",
    filter_bright: "Sáng",
    filter_contrast: "Nét",
    filter_blur: "Mờ",
    slot: "Ô",
    support_off: "Tắt hỗ trợ",
    support_on: "Hỗ Trợ Chụp",
    capturing: "Đang chụp...",
    processing: "Đang xử lý...",
    processing_subtitle: "Ảnh của bạn đang được xử lý...",
    manual_capture: "Chụp tay",
    retake_photo_btn: "Chụp lại ảnh #",
    auto_capture: "Tự động",
    continue_btn: "Tiếp tục",
    confirm_retake_all: "Bạn có chắc muốn chụp lại toàn bộ không? Các ảnh đã chụp sẽ bị mất.",
    retake_all_btn: "Chụp lại toàn bộ",
    countdown_label: "⏱️ Đếm ngược:",
    seconds: "giây",
    filter_title: "Bộ lọc màu",
    effect_title: "Hiệu ứng",
    effect_notice: "(Sẽ thấy sau khi bấm chụp)",
    settings_title: "Cài đặt Camera",
    select_camera: "Chọn camera:",
    camera_label: "Camera",
    switch_camera_tip: "Đổi cam trước/sau",
    mirror_label: "Phản chiếu camera (mirror)",
    sound_label: "Bật âm thanh chụp",
    flash_screen_label: "Bật hiệu ứng chớp trắng màn hình (Flash)",
    live_gif_label: "Quay video cùng ảnh chụp (5s)",
    close_btn: "Đóng",
    edit_title: "Chỉnh sửa ảnh",
    cancel_btn: "Hủy bỏ",
    apply_btn: "Áp dụng",
    crop_tip: "Crop cẩn thận bạn nhe!!!",
    support_modal_title: "Chọn Khung Hỗ Trợ Chụp",
    support_modal_desc: "Khung ảo trên camera để căn chỉnh. Khung thật sẽ được chọn ở bước cuối.",
    search_placeholder: "Tìm kiếm khung...",
    clear_support_btn: "Tắt khung hỗ trợ hiện tại"
  },
  result: {
    thanks: "Cảm ơn bạn đã sử dụng Web của tớ!",
    confirm_retake: "Bạn có muốn chụp lại không?",
    upload_success: "Cảm ơn bạn đã đóng góp ảnh!",
    upload_error: "Có lỗi xảy ra khi tải ảnh lên.",
    no_image_to_share: "Không tìm thấy ảnh để đóng góp.",
    error_load_frame: "Không thể tải khung riêng!",
    error_load_img: "Không thể tải khung:",
    error_invalid_file: "File không hợp lệ! Vui lòng chọn ảnh PNG.",
    cancel_btn: "Hủy",
    photo_num: "Ảnh",
    scroll_tip: "Lướt xuống để trang trí khung ảnh của bạn",
    bg_color: "Màu nền",
    photo_mode: "Chế độ ảnh",
    photo_frame: "Khung ảnh",
    use_custom_frame: "Dùng khung riêng",
    search_frame_placeholder: "Tìm kiếm khung ảnh...",
    complete_btn: "Hoàn thành",
    retake_btn: "Chụp lại",
    contribute_title: "Đóng góp cho thư viện",
    contribute_question: "Bạn có muốn chia sẻ ảnh của bạn cho Web chúng tôi không?",
    frame_upload_success: "Đã tải khung riêng thành công!",
    qr_success: "Đã tạo mã QR thành công!",
    qr_error: "Không thể tạo QR. Vui lòng thử lại.",
    zoom_photo: "Phóng to ảnh",
    share_qr_label: "Chia sẻ QR",
    creating_qr: "Đang tạo...",
    create_qr_btn: "Tạo QR",
    share_your_photo: "Chia sẻ ảnh của bạn",
    share_via_qr: "Chia sẻ bằng QR",
    generate_qr: "Tạo mã QR",
    select_download_title: "Chọn ảnh để tải xuống",
    download_photo_title: "Tải ảnh",
    save_all: "Lưu ảnh",
    save_one: "Lưu 1 tấm",
    download_btn: "Tải xuống",
    video_processing: "Đang xử lí...",
    download_video_btn: "Tải video",
    close_btn: "Đóng",
    your_photo_title: "Ảnh của bạn",
    loading_photo: "Đang tải ảnh...",
    one_photo: "1 ảnh",
    two_photos: "2 ảnh",
    custom_frame_title: "Tải lên khung riêng",
    frame_uploaded: "Khung đã tải lên",
    drag_drop_tip: "Kéo ảnh vào đây để dùng",
    or_click_tip: "hoặc nhấp để chọn file",
    yes_create_qr: "Có & Tạo QR",
    no_continue_qr: "Không, tiếp tục tạo QR",
    generating_qr: "Đang tạo mã QR",
    generating_qr_desc: "Website đang tạo mã QR chia sẻ ảnh cho bạn, vui lòng chờ tí nhé!",
    your_qr_title: "Mã QR của bạn",
    scan_qr_tip: "Mở camera điện thoại quét mã QR để tải ảnh nhé!",
    or_copy_link: "Hoặc copy link:",
    copied_link: "Đã copy link!",
    storage_notice: "Lưu ý: Ảnh này tồn tại trên hệ thống trong 1 tuần. Sau tuần này hệ thống tự động xoá!",
    storage_note_title: "Lưu ý",
    storage_note_part1: "Ảnh này tồn tại trên hệ thống trong",
    storage_note_duration: "1 tuần",
    storage_note_part2: ". Sau tuần này hệ thống tự động xoá!",
    thanks_title: "Cảm ơn bạn!",
    share_invite: "Hãy chia sẻ cho mọi người biết với nhé!",
    frame_update_notice: "Frame mới sẽ được liên tục cập nhật ^^",
    contribute_question_alt: "Bạn có muốn đóng góp ảnh vào bộ sưu tập chung không?",
    yes_contribute: "Có, đóng góp",
    no_thanks: "Không, cảm ơn",
    contribute_success: "Đã đóng góp thành công!",
  },
  share_view: {
    not_found: "Ảnh không tồn tại hoặc đã hết hạn",
    load_error: "Không thể tải ảnh. Vui lòng thử lại.",
    loading_title: "Đang tải ảnh...",
    loading_sub: "Hệ thống đang lấy ảnh từ máy chủ",
    error_title: "Không tìm thấy ảnh",
    home_btn: "Về trang chủ",
    header_title: "Chia sẻ ảnh",
    header_sub: "Được chia sẻ từ KenT Photobooth",
    one_photo: "1 ảnh",
    two_photos: "2 ảnh",
    tooltip_not_ready: "Phiên bản 2 ảnh chưa sẵn sàng",
    tooltip_ready: "Hiển thị 2 ảnh",
    tag_layout: "Layout:",
    tag_frame: "Có khung",
    tag_valid: "Còn hiệu lực 1 tuần",
    download_title: "Tải xuống",
    downloading: "Đang tải xuống...",
    download_btn: "Tải xuống ngay",
    cta_text: "Bạn cũng muốn tạo ảnh photobooth?",
    cta_btn: "Tạo ảnh của bạn",
    notice: "Lưu ý:",
    notice_server: "Ảnh này chỉ tồn tại 1 tuần và sẽ tự động xóa sau thời gian đó.",
    notice_local: "Link này chỉ hoạt động khi người chia sẻ còn ở trang web. Hãy tải ảnh về ngay!",
    tip: "Mẹo: Lưu ảnh vào thư viện để giữ kỷ niệm đẹp!",
    created_by: "Ảnh được tạo bởi",
    preparing: "Đang chuẩn bị ảnh...",
    preparing_sub: "Chúng tôi đang tối ưu hóa định dạng PNG cho bạn.",
    select_download_title: "Chọn ảnh để tải xuống",
    photo_num: "Ảnh",
    cancel_btn: "Hủy",
    download_btn: "Tải xuống",
    custom_frame_title: "Tải lên khung riêng",
    frame_uploaded: "Khung đã tải lên",
    drag_drop_tip: "Kéo ảnh vào đây để dùng",
    or_click_tip: "hoặc nhấp để chọn file",
    contribute_title: "Đóng góp cho thư viện",
    contribute_question: "Bạn có muốn chia sẻ ảnh của bạn cho Web chúng tôi không?",
    yes_create_qr: "Có & Tạo QR",
    no_continue_qr: "Không, tiếp tục tạo QR",
    generating_qr: "Đang tạo mã QR",
    generating_qr_desc: "Website đang tạo mã QR chia sẻ ảnh cho bạn, vui lòng chờ tí nhé!",
    your_qr_title: "Mã QR của bạn",
    scan_qr_tip: "Mở camera điện thoại quét mã QR để tải ảnh nhé!",
    or_copy_link: "Hoặc copy link:",
    copied_link: "Đã copy link!",
    storage_notice: "Lưu ý: Ảnh này tồn tại trên hệ thống trong 1 tuần. Sau tuần này hệ thống tự động xoá!",
    close_btn: "Đóng",
    thanks_title: "Cảm ơn bạn!",
    share_invite: "Hãy chia sẻ cho mọi người biết với nhé!",
    frame_update_notice: "Frame mới sẽ được liên tục cập nhật ^^",
    contribute_question_alt: "Bạn có muốn đóng góp ảnh vào bộ sưu tập chung không?",
    yes_contribute: "Có, đóng góp",
    no_thanks: "Không, cảm ơn",
    contribute_success: "Đã đóng góp thành công!",
    your_photo_title: "Ảnh của bạn",
    loading_photo: "Đang tải ảnh...",
    one_photo: "1 ảnh",
    two_photos: "2 ảnh",
    download_photo_title: "Tải ảnh",
    save_all: "Lưu ảnh",
    save_one: "Lưu 1 tấm",
    creating_qr: "Đang tạo...",
    create_qr_btn: "Tạo QR",
    share_your_photo: "Chia sẻ ảnh của bạn",
    share_via_qr: "Chia sẻ bằng QR"
  },
  welcome_modal: {
    title: "Chào mừng!",
    timer_title: "Chọn thời gian",
    timer_body: "Bạn có thể chọn thời gian đếm ngược cho mỗi lần chụp!",
    session_title: "Chụp liên tiếp",
    session_body: "Phiên chụp sẽ chụp các tấm ảnh liên tiếp — hãy tạo dáng thật đẹp nhé! 🌟",
    privacy_title: "Lưu ý bảo mật",
    privacy_body: "Trừ khi bạn dùng tính năng chia sẻ, website sẽ không lưu trữ bất kỳ ảnh nào bạn tải lên.",
    start_btn: "BẮT ĐẦU"
  },
  footer: {
    description: "Photobooth là nơi lưu giữ những khoảnh khắc đáng nhớ với chất lượng ảnh cao, giao diện thân thiện và nhiều hiệu ứng sáng tạo cho mọi lứa tuổi.",
    contact: "Liên hệ",
    total_visits: "Tổng Lượt Truy Cập:"
  }
};

export default vi;
